import { Link } from 'react-router-dom';
import type { Porta } from '../portas';

export default function CartaoPorta({ porta }: { porta: Porta }) {
  return (
    <Link
      to={porta.para}
      className="flex w-full cursor-pointer items-center gap-4 rounded-2xl border border-[#E7E3EF] bg-white p-5 shadow-[0_1px_3px_rgba(0,0,0,0.04)] transition-colors hover:border-primary-300 hover:bg-primary-50/50"
    >
      <span className="flex h-[34px] w-[34px] shrink-0 items-center justify-center text-primary-600">
        <i className={`${porta.icone} text-[26px]`} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[15px] font-medium text-foreground-950">{porta.titulo}</p>
        <p className="mt-0.5 text-sm text-secondary-500">{porta.descricao}</p>
      </div>
      <span className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-white">
        {porta.trabalho}
      </span>
    </Link>
  );
}